// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CYJL","tabsBox":"styles_tabsBox__2FC60","createButton":"styles_createButton__34Du_"};